import { all } from "redux-saga/effects";

import updateDeviceStatusSaga from "./updateDeviceStatus";
import getListNotificationSaga from "./getListNoti";
import updateNotiStatusSaga from "./updateNotiStatus";

export default function* notificationSaga() {
  yield all([
    updateDeviceStatusSaga(),
    getListNotificationSaga(),
    updateNotiStatusSaga(),
  ]);
}
